import React from 'react';
import ModalContentWrapper from "./ModalContentWrapper";

import './ModalNeedHelp.scss' ;

const ModalNeedHelp = (props) =>
{
    const onClickCancel = () => {
        props.onClose();
    }

    const cancelButton = () =>{
        return(
            <button className="btn btn-secondary nutritroops-btn-primary" onClick={onClickCancel} style={{marginRight: '10px'}}>Close</button>
        )
    }

    return (
        <ModalContentWrapper className="modal-login-help">

            <h3 className="modal-title" id="myModalLabel">Account / Login Help</h3>
            <p>To reset your password please select 'Forgot Password' and enter username set up for your account.</p>
            <p>This will be either your firstname.surname account name if you have a school360.co.uk email address, or your email address if you are a parent.</p>
            <p>If you can't remember yours or your child's login details, you will need to contact your child's school
                for help.</p>

            <p>If you need help accessing an existing account or need an
                account set up for a new member of your team please email &nbsp;
                <a href='mailto:julie.keenlyside@northumberland.gov.uk'>julie.keenlyside@northumberland.gov.uk</a>.</p>

            <p>If you require support with the use of School360 and its resources,
                please contact <a
                    href='mailto:jennifer.harris@northumberland.gov.uk'>jennifer.harris@northumberland.gov.uk &nbsp;</a>
                or <a href='mailto:jordan.graham@northumberland.gov.uk'>jordan.graham@northumberland.gov.uk</a></p>

            <div className='row'>
                <div className='col-md-6'></div>
                <div className='col-md-6' style={{textAlign: 'right', paddingTop: '20px'}}>{cancelButton()}</div>
            </div>
        </ModalContentWrapper>
    )
}

export default ModalNeedHelp;
